import { render, staticRenderFns } from "./MurdochHeader.vue?vue&type=template&id=65755068&"
import script from "./MurdochHeader.vue?vue&type=script&lang=js&"
export * from "./MurdochHeader.vue?vue&type=script&lang=js&"
import style0 from "./MurdochHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports